<template>
<v-dialog width="1000" v-model="show">
  <slot slot="activator" name="activator">
    <v-btn slot="activator">
      <v-icon>receipt</v-icon>
    </v-btn>
  </slot>

  <v-card>
    <v-card-title class="headline" primary-title>
      {{ $t('archive.add-file') }}
    </v-card-title>

    <v-container>
      <div>
        <v-text-field :label="`${$t('archive.choose_file')}`" @click="onPickFile" v-model='fileName' prepend-icon="attach_file"></v-text-field>
        <input type="file" style="display: none" ref="fileInput" :accept="getAllowedExtension()" @change="onFilePicked">
        <v-text-field :label="`${$t('separator')}`" v-model='separator'></v-text-field>
        <div v-for="(field,key) in getFirstLine()" v-if="dataFile.length > 0" :key="'upload-' + key">
          <v-text-field v-if="field.type != 'table'" width="80%" v-model="model[key]" :label="key+ 1 + ' Kolumne z pliku dopasuj do nr pola'" required></v-text-field>
        </div>
        <CsvView v-if="dataFile.length > 0" v-on:slice="slice($event)" :separator="separator" :dataFile="dataFile" />
        <v-btn :disabled="!this.isValid()" @click="upload()">{{$t('archive.upload')}}</v-btn>
        <v-progress-circular v-if="loading" color="primary" indeterminate></v-progress-circular>
      </div>
    </v-container>
  </v-card>
</v-dialog>
</template>

<script>
import CsvView from './form/CsvView'
const DEFAULT_ALLOWED_EXTENSION = ".csv"
export default {
  components: {
    CsvView
  },
  data() {
    return {
      model: [],
      separator: ";",
      fileName: "",
      file: undefined,
      show: false,
      operation: undefined,
      allowedOperations: [],
      loading: false,
      dataFile: []
    }
  },
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  created() {
  },
  methods: {
    slice(index) {
      this.dataFile.splice(index, 1)
    },
    getMap() {
      let fieldsMap = []
      for (let key in this.model) {
        let map = {}
        map.order = this.model[key]
        map.index = parseInt(key) + 1
        fieldsMap.push(map)
      }
      return fieldsMap
    },
    getFirstLine() {
      if (this.dataFile.length > 0) {
        return this.dataFile[0].split(this.separator)
      }
      return []
    },
    isValid() {
      return this.file != undefined && this.fileName != undefined && this.loading == false
    },
    onPickFile() {
      this.$refs.fileInput.click()
    },
    onFilePicked(event) {
      const files = event.target.files
      if (files[0] !== undefined) {

        if (files[0].name.lastIndexOf('.') <= 0) {
          return
        }
        this.fileName = files[0].name
        const fr = new FileReader()
        fr.readAsText(files[0])
        fr.addEventListener('load', () => {
          this.dataFile = fr.result.split("\n")
        })
      }
    },
    getAllowedExtension() {
      let operation = this.allowedOperations.find(el => el.id == this.operation)
      if (operation) {
        return operation.allowed_extension.map(ext => "." + ext).join(", ")
      }
      return DEFAULT_ALLOWED_EXTENSION
    }
  },
}
</script>

<style>

</style>
